import { FiCheck } from 'react-icons/fi';

import styles from './styles.module.scss';

interface IProps {
  password: string;
}

// Regras deste sistema (ver handleInputNewPassword em Home/index.tsx):
// /^(?=.*?[a-z])(?=.*?[0-9]).{8,}$/ — mínimo 8 caracteres, 1 letra e 1 número.
const passwordRequirements = [
  {
    label: 'Pelo menos 8 caracteres',
    test: (value: string) => value.length >= 8,
  },
  {
    label: 'Uma letra (a-z)',
    test: (value: string) => /[a-z]/.test(value),
  },
  {
    label: 'Um número (0-9)',
    test: (value: string) => /[0-9]/.test(value),
  },
];

export const PasswordRequirements = ({ password }: IProps) => (
  <div className={styles.container}>
    <p>Sua senha deve conter:</p>
    <ul>
      {passwordRequirements.map((requirement) => {
        const met = requirement.test(password);
        return (
          <li key={requirement.label} data-met={met}>
            <span className={styles.bullet}>
              {met && <FiCheck size={12} />}
            </span>
            {requirement.label}
          </li>
        );
      })}
    </ul>
  </div>
);
